export function DetailGrid({ details }: { details: Record<string, string> }) {
  const entries = Object.entries(details);

  return (
    <dl className="grid w-full grid-cols-1 gap-y-6 md:grid-cols-2 md:gap-x-4">
      {entries.map(([label, value]) => (
        <div key={label} className="w-full sm:col-span-2 md:col-span-1">
          <dt className="font-medium text-sm text-spark-text-secondary">{label}</dt>
          <dd className="mt-1 text-sm text-spark-text-primary">{value}</dd>
        </div>
      ))}
    </dl>
  );
}
